import React from "react";
import { useTranslation } from "react-i18next";
import { useSpring, animated } from "react-spring";
import "./ThermeEtCondition.css";

const TermsAndCondition = () => {
  const { t } = useTranslation();
  const fade = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 1000 },
  });

  return (
    <div className="termscondition">
      <div className="beneficiary">
        <div className="overlay-text">{t("termeEtConditionsDes")}</div>
      </div>
      <section className="about_section layout_padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <animated.div className="detail-box" style={fade}>
                <h5>{t("condition")}</h5>
                <hr
                  className="my-2"
                  style={{
                    width: "20%",
                    height: "2%",
                    backgroundColor: "green",
                    marginBottom: "10px",
                  }}
                />
                <p
                  className=""
                  style={{ fontFamily: "Light Italic", fontSize: "20px" }}
                >
                  {t("ClaimsDeclarationDescription")}
                </p>

                {/* Contexte */}
                <h3>{t("context.title")}</h3>
                <p
                  style={{ fontFamily: "Light Italic", fontSize: "18px" }}
                  dangerouslySetInnerHTML={{ __html: t("context.description") }}
                />

                {/* Termes et Conditions */}
                {[...Array(15)].map((_, index) => (
                  <div key={index + 1}>
                    <h4>{t(`terms.${index + 1}.title`)}</h4>
                    {index + 1 === 4 ? (
                      <>
                        <h5>{t("terms.4.content.4.1.title")}</h5>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: t("terms.4.content.4.1.content"),
                          }}
                        />
                        <h5>{t("terms.4.content.4.2.title")}</h5>
                        <p>{t("terms.4.content.4.2.content")}</p>
                      </>
                    ) : (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: t(`terms.${index + 1}.content`),
                        }}
                      />
                    )}
                  </div>
                ))}
              </animated.div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndCondition;